import React, { useState } from 'react';
import './OpenRoles.css';
import siteConfig from '../../configuration/siteConfiguration';

const jobListings = [
  {
    title: 'Full Stack Developer',
    tag: 'SOFTWARE DEVELOPMENT',
    description:
      'We are seeking a Full-Stack Developer to build and enhance scalable, high-performance AI-powered web applications that revolutionize legal research, case law analysis, contract automation, and intelligent diagnostics in healthcare.',
    details: [
      { icon: '/images/frame.svg', text: 'View job description' },
      { icon: '/images/frame1.svg', text: '2 to 4 yrs exp.' },
      { icon: '/images/frame2.svg', text: 'Bengaluru, Karnataka' },
      { icon: '/images/frame3.svg', text: 'Remote / Hybrid' },
    ],
  },
  {
    title: 'UI/UX Developer',
    tag: 'SOFTWARE DEVELOPMENT',
    description:
      'We are seeking a UI/UX Developer with expertise in user experience research, wireframing, prototyping, and front-end development. The ideal candidate will work on intuitive interfaces and seamless user experiences in Legal AI, Healthcare AI, and SaaS platforms.',
    details: [
      { icon: '/images/frame.svg', text: 'View job description' },
      { icon: '/images/frame1.svg', text: '3 to 5 yrs exp.' },
      { icon: '/images/frame2.svg', text: 'Bengaluru, Karnataka' },
      { icon: '/images/frame3.svg', text: 'Remote / Hybrid' },
    ],
  },
];

function OpenRoles() {
  const [applyingIndex, setApplyingIndex] = useState(null);
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    linkedin: '',
    why: '',
    resume: null,
  });
  const [formTouched, setFormTouched] = useState(false);
  const [submissionSuccess, setSubmissionSuccess] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };
  const handleFileChange = (e) => {
    setForm((prev) => ({ ...prev, resume: e.target.files[0] }));
  };
  const handleDeleteResume = (e) => {
    e.stopPropagation();
    setForm((prev) => ({ ...prev, resume: null }));
  };
  const handleReplaceResume = (e) => {
    e.stopPropagation();
    document.getElementById('resume-upload-input').click();
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormTouched(true);
    if (isFormValid) {
      try {
        const response = await fetch(`${siteConfig.apiBaseUrl}/leads/create`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            first_name: form.firstName,
            last_name: form.lastName,
            email: form.email,
            mobile: form.mobile,
            linked_in_profile: form.linkedin,
            message: form.why,
            source_id: 'web.cognitva.ai',
            source_context: 'careers',
          }),
        });
        if (response.ok) {
          setSubmissionSuccess(true);
        } else {
          // Optionally handle error here
          setSubmissionSuccess(false);
          const errorText = await response.text();
          alert('Failed to submit application: ' + errorText);
        }
      } catch (error) {
        setSubmissionSuccess(false);
        alert('Error submitting application: ' + error.message);
      }
    }
  };
  const isFormValid =
    form.firstName.trim() &&
    form.lastName.trim() &&
    form.email.trim() &&
    form.mobile.trim() &&
    form.linkedin.trim() &&
    form.why.trim() /*&&
    form.resume; */

  if (applyingIndex !== null) {
    const job = jobListings[applyingIndex];
    return (
      <div className="job-application-container">
        <div className="job-application-left">
          <button
            className="back-to-roles"
            onClick={() => setApplyingIndex(null)}
          >
            &larr; Back to roles
          </button>
          <div className="job-title-row">
            <h1 className="job-title">{job.title}</h1>
            <span className="job-tag-app">
              <img
                src="/images/ellipse.svg"
                alt="ellipse"
                className="job-tag-icon"
              />{' '}
              {job.tag}
            </span>
          </div>
          <p className="job-description-app">{job.description}</p>
          <div className="job-details-app">
            {job.details.map((detail, i) => (
              <span key={i} className="job-detail-app">
                <img src={detail.icon} alt={detail.text} /> {detail.text}
                {i < job.details.length - 1 && (
                  <span className="job-detail-separator">|</span>
                )}
              </span>
            ))}
          </div>
        </div>
        <form className="job-application-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Name *</label>
              <input
                type="text"
                name="firstName"
                placeholder="First name"
                value={form.firstName}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label>&nbsp;</label>
              <input
                type="text"
                name="lastName"
                placeholder="Last name"
                value={form.lastName}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              placeholder="Email address"
              value={form.email}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Mobile number *</label>
            <input
              type="text"
              name="mobile"
              placeholder="+91  Contact number"
              value={form.mobile}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>LinkedIn profile *</label>
            <input
              type="text"
              name="linkedin"
              placeholder="Please provide a link to your LinkedIn profile"
              value={form.linkedin}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Why would you want to work at Cognitva? *</label>
            <textarea
              name="why"
              placeholder="Tell us why you want to join our team"
              value={form.why}
              onChange={handleInputChange}
            />
          </div>
          {/* <div className="form-group">
            <label>Resume *</label>
            <div className="resume-upload-area" onClick={!form.resume ? () => document.getElementById('resume-upload-input').click() : undefined}>
              <input
                id="resume-upload-input"
                type="file"
                accept="application/pdf"
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
              <img src="/images/upload.svg" alt="Upload" className="resume-upload-icon" />
              {form.resume ? (
                <>
                  <span className="resume-upload-text">{form.resume.name}</span>
                  <span className="resume-upload-delete" onClick={handleDeleteResume}>
                    <img src="/images/deleteicon.svg" alt="Delete" />
                  </span>
                  <img src="/images/separator.svg" alt="separator" className="resume-upload-separator" />
                  <span className="resume-upload-replace" onClick={handleReplaceResume}>Replace</span>
                </>
              ) : (
                <span className="resume-upload-text">Upload a PDF file</span>
              )}
            </div>
          </div> */}
          {!submissionSuccess ? (
            <button
              className="submit-application-btn"
              type="submit"
              disabled={!isFormValid}
            >
              Submit application
              <img
                src="/images/submitarrow.svg"
                alt="Submit"
                className="submit-arrow-icon"
              />
            </button>
          ) : (
            <div className="success-message-bar">
              <span className="success-icon-bar">
                <img src="/images/success.svg" alt="Success" />
              </span>
              <span className="success-text-bar">
                Great! Your resume has been submitted successfully. We appreciate
                your interest in the position!
              </span>
            </div>
          )}
        </form>
      </div>
    );
  }

  return (
    <section className="open-roles" id="open-roles-section">
      <p className="section-label">— OPEN ROLES</p>
      <div className="open-roles-header-content">
        <h2>
          Join us in building the future of
          <br />
          AI-driven enterprises
        </h2>
        <div className="intro-container">
          <p className="intro-text-secondary">
            If you're curious, collaborative, and committed to solving hard
            problems that matter — we'd love to meet you
          </p>
        </div>
      </div>

      <div className="job-listings-wrapper">
        <hr className="job-listing-separator" />
        {jobListings.map((job, index) => (
          <React.Fragment key={index}>
            <div className="job-listing">
              <div className="job-header">
                <h3>{job.title}</h3>
                <span className="job-tag">
                  <img
                    src="/images/ellipse.svg"
                    alt="ellipse"
                    className="job-tag-icon"
                  />
                  {job.tag}
                </span>
              </div>
              <p className="job-description">{job.description}</p>
              <div className="job-details">
                {job.details.map((detail, detailIndex) => (
                  <React.Fragment key={detailIndex}>
                    <div className="detail-item">
                      <img
                        src={detail.icon}
                        alt={detail.text}
                        width="20"
                        height="20"
                      />
                      <span>{detail.text}</span>
                    </div>
                    {detailIndex < job.details.length - 1 && (
                      <img
                        src="/images/separator.svg"
                        alt="separator"
                        className="detail-separator"
                      />
                    )}
                  </React.Fragment>
                ))}
                <img
                  src="/images/separator.svg"
                  alt="separator"
                  className="detail-separator"
                />
                <button
                  className="apply-now-btn"
                  onClick={() => setApplyingIndex(index)}
                >
                  Apply now
                </button>
              </div>
            </div>
            {index < jobListings.length - 1 && (
              <hr className="job-listing-separator" />
            )}
          </React.Fragment>
        ))}
        <hr className="job-listing-separator" />
      </div>

      <p className="contact-info">
        Don't see a role that fits exactly? Write to us anyway — we're always
        excited to meet exceptional talent
        <br />
        write to us at{' '}
        <a href="mailto:hr@cognitva.ai">hr@cognitva.ai</a>
      </p>
    </section>
  );
}

export default OpenRoles;